<template>
  <div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
  name: 'AuthLogout',

  computed: mapGetters(['getLoggedIn']),

  methods: {
    ...mapActions(['fetchAuthLogout']),
  },

  mounted() {
    this.fetchAuthLogout()
    this.$router.push({ name: 'Home' })
    this.$router.go(0)
  },
}
</script>

<style scoped lang="scss">
</style>
